import { setAlertMessage, setAlertTypePrimary, setAlertTypeDanger, showAlert, hideAlert } from '../redux/setAlertDetails';
import { getDetailedMessage } from '../api/getDetailedMessage';
import { store } from '../../store/store';

export function loadingEffectStart() {
    document.getElementById("appBody").style.cursor = "progress";
    document.getElementById("appBody").style.opacity = "0.2";
    document.getElementById("submitButton").style.cursor = "progress";
    document.getElementById("submitButton").disabled = true;
}
export function loadingEffectStop() {
    document.getElementById("appBody").style.cursor = "default";
    document.getElementById("appBody").style.opacity = "1.0";
}
export function resetButtonEffect() {
    document.getElementById("submitButton").style.cursor = "pointer";
    document.getElementById("submitButton").disabled = false;
}
export function primaryError(msg) {
    store.dispatch(setAlertMessage(msg));
    store.dispatch(setAlertTypePrimary());
    store.dispatch(showAlert());
    loadingEffectStop();
    resetButtonEffect();
    console.log(msg);
    setTimeout(() => { store.dispatch(hideAlert()); }, 5000);
}
export function majorError(msg) {
    let detailedMessage = getDetailedMessage(msg);
    store.dispatch(setAlertMessage(detailedMessage));
    store.dispatch(setAlertTypeDanger());
    store.dispatch(showAlert());
    loadingEffectStop();
    resetButtonEffect();
    console.log(detailedMessage);
    setTimeout(() => { store.dispatch(hideAlert()); }, 8000);
}